import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function PinDialog({ open, pinSet, onClose, onSubmit, busy }) {
  const [pin, setPin] = useState("");
  useEffect(() => {
    if (open) setPin("");
  }, [open]);
  let submitLabel = "Set PIN & unlock";
  if (pinSet) submitLabel = "Unlock";
  if (busy) submitLabel = "Checking…";
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent aria-describedby={undefined} className="border-slate-200 bg-white text-slate-900" data-testid="pin-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl uppercase tracking-wide">
            {pinSet ? "Admin sign in" : "Set the admin PIN"}
          </DialogTitle>
        </DialogHeader>
        {!pinSet && (
          <p className="text-sm text-slate-500">No PIN set yet. The first PIN entered becomes the permanent admin PIN — share it privately.</p>
        )}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(pin);
          }}
          className="space-y-4"
        >
          <input
            data-testid="pin-input"
            type="password"
            inputMode="numeric"
            autoFocus
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            placeholder="PIN (min 4 characters)"
            className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-base tracking-widest text-slate-900 outline-none focus:border-orange-400"
          />
          <button
            data-testid="pin-submit-button"
            type="submit"
            disabled={busy || pin.trim().length < 4}
            className="w-full rounded-lg bg-orange-500 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-400 disabled:opacity-40"
          >
            {submitLabel}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
